import Vue from 'vue';
import Router from 'vue-router';
import store, { IS_LOGGED_IN, FETCH_HISTORY } from '@/store';

// Views
import HomePage from '@/views/home/HomePage.vue';
import DashboardPage from '@/views/dashboard/DashboardPage.vue';
import ErrorPage from '@/views/error/ErrorPage.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage,
      beforeEnter: (to, from, next) => {
        store.getters[IS_LOGGED_IN] ? next({ name: 'dashboard' }) : next();
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: DashboardPage,
      beforeEnter: (to, from, next) =>
        store.getters[IS_LOGGED_IN] ? next() : next({ name: 'home' })
    },
    {
      path: '/not-found',
      name: 'error',
      component: ErrorPage
    },
    { path: '*', redirect: '/not-found' }
  ]
});
